/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_pollwidget_optionplaceholder2 = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`옵션 ${i?.number}`)
};

const en_pollwidget_optionplaceholder2 = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Option ${i?.number}`)
};

const ja_pollwidget_optionplaceholder2 = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`オプション ${i?.number}`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ number: NonNullable<unknown> }} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const pollwidget_optionplaceholder2 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pollwidget_optionplaceholder2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("pollwidget_optionplaceholder2", locale)
	if (locale === "ko") return ko_pollwidget_optionplaceholder2(inputs)
	if (locale === "en") return en_pollwidget_optionplaceholder2(inputs)
	return ja_pollwidget_optionplaceholder2(inputs)
};
export { pollwidget_optionplaceholder2 as "pollWidget_optionPlaceholder" }